import { render } from "./MainSection.vue?vue&type=template&id=a8c80584&scoped=true"
import script from "./MainSection.vue?vue&type=script&lang=js"
export * from "./MainSection.vue?vue&type=script&lang=js"

import "./MainSection.vue?vue&type=style&index=0&id=a8c80584&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8c80584"]])

export default __exports__